<div class="faq-detail-container">
    <div class="nav-container">
        <button class="btn link-btn btn-back">
            <i class="app-icon icon icon-chevron-left icon-xl" (click)="redirectFAQManager()"></i>
        </button>
        <span class="fw-semibold ms-3">{{'faqManager.title' | translate}}</span>
    </div>
    <form #form="ngForm">
        <div class="form-input-container">
            <div class="row">
                <div class="col-12 wizard-question">
                    {{'faqManager.details.title' | translate}}
                </div>
            </div>
            <div class="row justify-content-center my-3">
                <div class="col-md-10 col-lg-8 col-xl-8 col-xxl-7 col-xxxl-6">
                    <div class="label-input">{{'faqManager.details.question' | translate}}
                        <span class="text-primary fw-bold"> * </span>
                    </div>
                    <input 
                        class="text-input"
                        kendoTextBox
                        name="question"
                        #question="ngModel"
                        type="text"
                        placeholder="{{ 'faqManager.details.questionPlaceholder' | translate }}"
                        [(ngModel)]="faq.question" 
                        [value]="faq.question"
                        [ngClass]="{'form-submitted': form.submitted}"
                        required
                        >
                    <div class="error-info" *ngIf="question.invalid  && (question.dirty || question.touched || form.submitted)">
                        <div *ngIf="question.errors?.['required']" >
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center my-3">
                <div class="d-flex flex-column col-md-10 col-lg-8 col-xl-8 col-xxl-7 col-xxxl-6">
                    <div class="label-input">{{'faqManager.details.answer' | translate}}
                        <span class="text-primary fw-bold"> *</span>
                    </div>
                    <kendo-editor class="flex-grow-1 kendo-editor-resizable-vertical" 
                        [iframe]="false"
                        [resizable]="resizable"
                        name="answer"
                        (focus)="isEditorFocused = true"
                        (blur)="isEditorFocused = false"
                        [ngClass]="{'editor-focus': isEditorFocused, 'form-submitted': form.submitted }"
                        [(ngModel)]="faq.answer" 
                        #answer = "ngModel"
                        required> 
                    </kendo-editor>
                    <div class="error-info" *ngIf="answer.invalid  && (answer.dirty || answer.touched || form.submitted)">
                        <div *ngIf="answer.errors?.['required']" >
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>
                    <div class="justify-content-start">
                        <span>{{'faqManager.details.requiredFieldsInfo1' | translate}}</span>
                        <span class="text-primary fw-bold"> * </span>
                        <span>{{'faqManager.details.requiredFieldsInfo2' | translate}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <button class="btn primary-btn px-4" (click)="saveFAQHandler()" [disabled]="loading">
                <span>{{'faqManager.details.publishBtn' | translate}}</span>
            </button>
        </div>
    </form>
</div>